import React, {FC} from "react"

import Button from "@irati/ui/src/Button"
import FormattedMessage from "@irati/utils/lang"
import {ValidationButton} from "@irati/ui/src/FormItem"

import {StyledFooter} from "../../Modal/styled"
import {StyledButton} from "./styled"

interface Props {
  isPreviewView: boolean
  onSubmit: () => void
  showPreview: (value: boolean) => void
}

const CompanyNewsContentFooter: FC<Props> = ({isPreviewView, showPreview, onSubmit}) => {
  if (isPreviewView) {
    return (
      <StyledFooter>
        <Button onClick={() => showPreview(false)}>
          <FormattedMessage id="platform.homepage.companyNews.newContent.closePreview" />
        </Button>
      </StyledFooter>
    )
  }

  return (
    <StyledFooter>
      <StyledButton onClick={() => showPreview(true)}>
        <FormattedMessage id="platform.homepage.companyNews.newContent.preview" />
      </StyledButton>

      <ValidationButton primary onClick={onSubmit}>
        <FormattedMessage id="platform.homepage.companyNews.newContent.save" />
      </ValidationButton>
    </StyledFooter>
  )
}

export default CompanyNewsContentFooter
